import * as React from 'react';
import Animatable from './Animatable';
import { View, Text, IconButton, rem } from '../libs/WebComponents';
import { Props } from '../types/types';
import { HandleFetchError } from '../api/api-root';
import { wpAuthGET } from '../api/api-user';
import { usePopupStore } from '../store/popups';
import AppTipsGeneral from '../Pages/AppTipsGeneral';

const GeneralTipContainer = (props: Props)=>{

   const { addPopup, removePopup } = usePopupStore();
   const [loading, setLoading] = React.useState(false);

   const showGeneralTip = React.useCallback(async()=>{
      try{
         setLoading(true);
         const results: {post_content: string, page_type: string} = await wpAuthGET('pages/app-tips', {group_id: props.group.ID});
         if (results)
         {
            const post_content: string = results.post_content;
            const uuid = addPopup({type:results.page_type, children: <AppTipsGeneral body={post_content} onClose={()=>removePopup(uuid)} />});
         }
      }catch(err: HandleFetchError | any)
      {
         console.warn(err);
      }finally{
         setLoading(false);
      }
   },[props.group]);

   return (
      <Animatable.View animation={'fadeIn'} className="general-tip-container">
         <View className="box">
            <Animatable.View animation={'slideInUp'} duration={300} className="inner">
               <IconButton name={`${loading?'Loader':'Lightbulb'}`} containerClassName={loading?'spin':''} iconSize={rem(6)} size={rem(7)} onPress={showGeneralTip} color={'var(--color-orange-light)'} />
               <Text>Uitleg over de vragen</Text>
            </Animatable.View>
         </View>
      </Animatable.View>
   );
}

export default React.memo(GeneralTipContainer);